import Quill from 'quill';

const BlockEmbed = Quill.import("blots/block/embed");

export default class extends BlockEmbed {
  static blotName = "video";
  static tagName = "p";
  static className = "ql-iframe";

  static create(url) {
    const node = super.create(url);
    const iframe = document.createElement("iframe");

    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", true);
    iframe.setAttribute("src", url);

    node.appendChild(iframe);

    return node;
  }

  static value(domNode) {
    const iframe = domNode.querySelector("iframe");

    return iframe.getAttribute("src");
  }
}
